import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LinkedInSidebar from '../LinkedInSidebar';
import axios from "axios";
import Cookies from "js-cookie";
import { SquareX, SquareCheck, Info, Loader2, Check } from "lucide-react";
import Modal from '../Elements/Modal';
import TableFromJson from '../Elements/TableFromJson';
import Notification from './Notification';
import ReactMarkdown from 'react-markdown';
import ToggleBlock from '../Elements/ToggleBlock';


const CompanyPage = ({ currentPage, setCurrentPage }) => {
  const { slug, id } = useParams();
  const navigate = useNavigate();

  const navigateToPage = (page) => {
    navigate(`/${page === 'feed' ? '' : page}`);
  };
  const [aiMessages, setAiMessages] = useState([]);
  const [loadingAi, setLoadingAi] = useState(false);
  const [loadingMetricsAi, setLoadingMetricsAi] = useState(false);
  const [loadingCountryAi, setLoadingCountryAi] = useState(false);
  const [loadingSectorAi, setLoadingSectorAi] = useState(false);
  const [loadingIndustryAi, setLoadingIndustryAi] = useState(false);
  const [loadingNewsAi, setLoadingNewsAi] = useState(false);
  const [loadingGeneralAi, setLoadingGeneralAi] = useState(false);
  const [companyUndervalues, setCompanyUndervalues] = useState("");
  const [errorAI, setErrorAI] = useState("");
  
  

  const [isModalOpenCR, setIsModalOpenCR] = useState(false);
  const [isModalOpenPBR, setIsModalOpenPBR] = useState(false);
  
  const [activeReportTab, setActiveReportTab] = useState('income');

  const [incomeReport, setIncomeReport] = useState([]);
  const [balanceSheetReport, setBalanceSheetReport] = useState([]);
  const [cashFlowReport, setCashFlowReport] = useState([]);

  const [companyId, setCompanyId] = useState(0);
  const [authStatus, setAuthStatus] = useState(null);
  const [notificationEnabled, setNotificationEnabled] = useState(null);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [searchResults, setsearchResults] = useState([]);
  const canShowSearchRef = useRef(true);

  const [showChartCF, setShowChartCF] = useState(false);
  const [showChartEPS, setShowChartEPS] = useState(false);
  const [showChartRPS, setShowChartRPS] = useState(false);

  const [cashFlowLabels, setCashFlowLabels] = useState([]);
  const [cashFlowValues, setCashFlowValues] = useState([]);
  // const [cashFlowGrowthValues, setCashFlowGrowthValues] = useState<number[]>([]);
  const [cashFlowAllData, setCashFlowAllData] = useState([{
    year: 0,
    value: 0,
    difference: 0
  }]);

  const [epsLabels, setEpsLabels] = useState([]);
  const [epsValues, setEpsValues] = useState([]);
  // const [epsGrowthValues, setEpsGrowthValues] = useState<number[]>([]);
  const [epsAllData, setEpsAllData] = useState([{
    year: 0,
    value: 0,
    difference: 0
  }]);

  const [revenueLabels, setRevenueLabels] = useState([]);
  const [revenueValues, setRevenueValues] = useState([]);
  // const [revenueGrowthValues, setRevenueGrowthValues] = useState<number[]>([]);
  const [revenueAllData, setRevenueAllData] = useState([{
    year: 0,
    value: 0,
    difference: 0
  }]);

  const [companyDetails, setCompanyDetails] = useState({
    id: 0,
    symbol: "",
    cik: "",
    company_name: "",
    stock_price: 0,
    stock_price_years_number: 10,
    country: "",
    market_cap: 0,
    industry: "",
    sector: "",
    image: "",
    website: "",
    description: "",
    calculation_results: {
      cr: 0,
      pe: {
          pe: 0,
          pe_3y: 0
      },
      ps: {
          ps: 0,
          ps_3y: 0
      },
      dar: {
          dar: 0,
          dar_10y: 0,
          dar_difference: 0
      },
      eps: {
          eps: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          eps_json: [{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0}],
          eps_growth: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          eps_growth_json: [{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0}],
          eps_growth_avg_3y: 0,
          eps_growth_avg_10y: 0,
          future_stock_price: {
              low: 0,
              high: 0,
              low_3y_model: 0,
              high_3y_model: 0,
          }
      },
      odd: 0,
      pbr: 0,
      pcf: {
          pcf: 0,
          pcf_3y: 0
      },
      roe: {
          roe: 0,
          roe_10y: 0,
          roe_difference_10y: 0,
      },
      bvps: 0,
      revenue: {
          revenue_all: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          revenue_per_share: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          revenue_per_share_json: [{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0}],
          future_stock_price: {
              low: 0,
              high: 0,
              low_3y_model: 0,
              high_3y_model: 0
          },
          revenue_per_share_growth: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          revenue_per_share_growth_json: [{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0}],
          revenue_per_share_growth_avg_3y: 0,
          revenue_per_share_growth_avg_10y: 0
      },
      potential_grow: {
          sector_global: 0,
          sector_country: 0,
          largest_company_in_sector: 0
      },
      operating_ratio: {
          operating_ratio: 0,
          operating_ratio_10y: 0,
          operating_ratio_difference: 0
      },
      net_profit_margin: {
          net_profit_margin: 0,
          net_profit_margin_10y: 0,
          net_profit_margin_difference: 0,
      },
      free_cash_flow_per_share: {
          future_stock_price: {
              low: 0,
              high: 0,
              low_3y_model: 0,
              high_3y_model: 0,
          },
          free_cash_flow_per_share: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          free_cash_flow_per_share_json: [{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0}],
          free_cash_flow_per_share_growth: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          free_cash_flow_per_share_growth_json: [{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0},{year: 0,value: 0}],
          free_cash_flow_per_share_growth_avg_3y: 0,
          free_cash_flow_per_share_growth_avg_10y: 0
      },
      dividend: {
        dividend_yields: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        difference_dividend_yield: 0
      }
    },
    cd_gdp: 0,
    ty_10y: 0,
    success_rate: 0,
    text_analysis: ""
  });

  function mergeYearlyData(cashFlowInput, cashFlowGrowth) {
    const growthMap = new Map(
      cashFlowGrowth.map((item) => [item.year, item.value])
    );
  
    return cashFlowInput.map((item) => ({
      year: item.year,
      value: parseFloat(item.value.toFixed(4)), // округление до 4 знаков
      difference: parseFloat((growthMap.get(item.year) ?? 0).toFixed(2)), // берем значение из growth или 0
    })).sort((a, b) => b.year - a.year);;
  }

  useEffect(() => {
    getCompanyDetails(id);
  }, []);

  async function getCompanyDetails(company_id) {
    setLoading(true);
    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiURL}/get-company-details`, { token: Cookies.get('token'), company_id: company_id });

      if(response.data.status == 'ok') {
        document.title = response.data.result.company_name + " - Fractofolio";
        const description = document.querySelector('meta[name="description"]');
        if (description) {
          description.setAttribute(
            'content',
            `Evaluation of ${response.data.result.company_name} based on 20+ parameters: Success Rate, P/E Ratio (Price-to-Earnings), P/CF Ratio (Price-to-Cash Flow), P/S Ratio (Price-to-Sales), OR (Operating Ratio), NPM (Net Profit Margin), D/A Ratio (Debt-to-Asset), Current Ratio (CR), ROE (Return on Equity), P/B Ratio (Price-to-Book), ODP (One Dollar Premise), Dividend Yield (DY), Potential Growth, FCF (Free Cash Flow per Share), EPS (Earnings per Share), RPS (Revenue per Share), and others.`
          );
        } else {
          // Если тега <meta name="description"> нет, создаём его
          const meta = document.createElement('meta');
          meta.name = 'description';
          meta.content = `Evaluation of ${response.data.result.company_name} based on 20+ parameters: Success Rate, P/E Ratio (Price-to-Earnings), P/CF Ratio (Price-to-Cash Flow), P/S Ratio (Price-to-Sales), OR (Operating Ratio), NPM (Net Profit Margin), D/A Ratio (Debt-to-Asset), Current Ratio (CR), ROE (Return on Equity), P/B Ratio (Price-to-Book), ODP (One Dollar Premise), Dividend Yield (DY), Potential Growth, FCF (Free Cash Flow per Share), EPS (Earnings per Share), RPS (Revenue per Share), and others.`;
          document.head.appendChild(meta);
        }

        // const updatedCompanyDetails = {
        //   ...response.data.result,
        //   description: response.data.result.description.length > 256 ? `${response.data.result.description.slice(0, 256)}...` : response.data.result.description,
        // };

        // setCompanyDetails(updatedCompanyDetails);

        setAuthStatus(response.data.auth_status);
        setNotificationEnabled(response.data.notification_enabled);
        console.log("response.data.notification_enabled: ", response.data.notification_enabled)

        setIncomeReport(response.data.reports.income);
        setBalanceSheetReport(response.data.reports.balance_sheet);
        setCashFlowReport(response.data.reports.cash_flow);

        const rawDetails = response.data.result;
      
        const updatedCompanyDetails = {
          ...rawDetails,
          description:
            rawDetails.description.length > 256
              ? `${rawDetails.description.slice(0, 256)}...`
              : rawDetails.description,
        };
      
        // // Округляем все числовые значения (кроме id) до 4 знаков
        // Object.entries(updatedCompanyDetails.calculation_results).forEach(([key, value]) => {
        //   if (key !== "id" && typeof value === "number") {
        //     updatedCompanyDetails.calculation_results[key] = parseFloat(value.toFixed(2));
        //   } else if (Array.isArray(value)) {
        //     // Проверяем, является ли значение массивом объектов YearlyData[]
        //     updatedCompanyDetails.calculation_results[key] = value.map((item) => ({
        //       year: item.year,
        //       value: parseFloat(item.value.toFixed(2)),
        //     }));
        //   } else {

        //   }
        // });

        const cash_flow_all = mergeYearlyData(response.data.result.calculation_results.free_cash_flow_per_share.free_cash_flow_per_share_json, response.data.result.calculation_results.free_cash_flow_per_share.free_cash_flow_per_share_growth_json)
        const eps_all = mergeYearlyData(response.data.result.calculation_results.eps.eps_json, response.data.result.calculation_results.eps.eps_growth_json)
        const revenue_all = mergeYearlyData(response.data.result.calculation_results.revenue.revenue_per_share_json, response.data.result.calculation_results.revenue.revenue_per_share_growth_json)

        setCompanyDetails(updatedCompanyDetails);
        setCashFlowAllData(cash_flow_all);
        setEpsAllData(eps_all);
        setRevenueAllData(revenue_all);

        // Chart Data
        const cash_flow_labels = cash_flow_all.map(item => item.year.toString());
        const cash_flow_values = cash_flow_all.map(item => parseFloat(item.value.toFixed(4))); 
        // const cash_flow_growth_values = cash_flow_all.map(item => parseFloat(item.difference.toFixed(2))); 

        const eps_labels = eps_all.map(item => item.year.toString());
        const eps_values = eps_all.map(item => parseFloat(item.value.toFixed(4))); 
        // const eps_growth_values = eps_all.map(item => parseFloat(item.difference.toFixed(2))); 

        const revenue_labels = revenue_all.map(item => item.year.toString());
        const revenue_values = revenue_all.map(item => parseFloat(item.value.toFixed(4))); 
        // const revenue_growth_values = revenue_all.map(item => parseFloat(item.difference.toFixed(2))); 

        setCashFlowLabels(cash_flow_labels);
        setCashFlowValues(cash_flow_values);
        // setCashFlowGrowthValues(cash_flow_growth_values);

        setEpsLabels(eps_labels);
        setEpsValues(eps_values);
        // setEpsGrowthValues(eps_growth_values);

        setRevenueLabels(revenue_labels);
        setRevenueValues(revenue_values);
        // setRevenueGrowthValues(revenue_growth_values);

      }

    } catch (error) {
      console.error("Error sending POST request:", error);
      await getCompanyDetails(company_id);
    } finally {
      setLoading(false);
      setFirstLoad(false);
    }
  }

  function canConvertToNumber(value) {
    return !isNaN(Number(value)) && !isNaN(parseFloat(value));
  }

  function countDecimalPlaces(num) {
    const numStr = num.toString();
    if (numStr.includes('.')) {
      return numStr.split('.')[1].length;
    }
    return 0;
  }

  function countCoreNumber(num) {
    const numStr = num.toString();
    if (numStr.includes('.')) {
      return numStr.split('.')[0].length;
    }
    return num.toString().length;
  }

  function converToCorrectValue(value) {
    if (typeof value === "string") {
      if (value.endsWith("%")) {
        const num_input = Number(value.replace("%", ""));
        const num = converToCorrectValue(num_input);
        const result = num.toString() + "%";
        return result;
      } else if (value.startsWith("1 / ")) {
        const num_input = Number(value.replace("1 / ", ""));
        const num = converToCorrectValue(num_input);
        const result = "1 / " + num.toString();
        return result;
      } else {
        if(canConvertToNumber(value)) {
          const num = Number(value)
          const decimal_number = countDecimalPlaces(num);
          if(decimal_number > 2) {
            return num.toFixed(4);
          }
          return value
        } else {
          return value
        }
      }
    } else {
      const decimal_number = countDecimalPlaces(value);
      const core_number = countCoreNumber(value);
      
      if(core_number < 1) {
        if(decimal_number > 4) {
          return value.toFixed(4);
        } else {
          return value
        }
      } else {
        if(decimal_number > 2) {
          return value.toFixed(2);
        } else {
          return value
        }
      }
    }
  }

  const delay = (ms) => new Promise(
    resolve => setTimeout(resolve, ms)
  );

  async function runAiAnalysis() {
    setLoadingAi(true);
    setLoadingMetricsAi(true);
    setLoadingCountryAi(true);
    setLoadingSectorAi(true);
    setLoadingIndustryAi(true);
    setLoadingNewsAi(true);
    setLoadingGeneralAi(true);

    const metricsAnalysis = await runAiAnalysisAPI('/ai/get_metrics_analysis');
    if(metricsAnalysis.status == "ok") {
      const m = {type: "metrics", text: metricsAnalysis.text_analysis}
      setAiMessages(prev => {
        const isTypeExists = prev.some(msg => msg.type === m.type);
        if (isTypeExists) {
          return prev; // не добавляем m, если такой type уже есть
        }
        return [...prev, m]; // добавляем, если type уникален
      });
      await delay(1000);
      scrollToBottom();
    } else {
      setErrorAI(metricsAnalysis.message);
      setLoadingAi(false);
      return ""
    }
    setLoadingMetricsAi(false);

    const countryAnalysis = await runAiAnalysisAPI('/ai/get_country_analysis');
    if(countryAnalysis.status == "ok") {
      const m = {type: "country", text: countryAnalysis.text_analysis}
      setAiMessages(prev => {
        const isTypeExists = prev.some(msg => msg.type === m.type);
        if (isTypeExists) {
          return prev; // не добавляем m, если такой type уже есть
        }
        return [...prev, m]; // добавляем, если type уникален
      });
      await delay(1000);
      scrollToBottom();
    } else {
      setErrorAI(countryAnalysis.message);
      setLoadingAi(false);
      return ""
    }
    setLoadingCountryAi(false);

    const sectorAnalysis = await runAiAnalysisAPI('/ai/get_sector_analysis');
    if(sectorAnalysis.status == "ok") {
      const m = {type: "sector", text: sectorAnalysis.text_analysis}
      setAiMessages(prev => {
        const isTypeExists = prev.some(msg => msg.type === m.type);
        if (isTypeExists) {
          return prev; // не добавляем m, если такой type уже есть
        }
        return [...prev, m]; // добавляем, если type уникален
      });
      await delay(1000);
      scrollToBottom();
    } else {
      setErrorAI(sectorAnalysis.message);
      setLoadingAi(false);
      return ""
    }
    setLoadingSectorAi(false);

    const industryAnalysis = await runAiAnalysisAPI('/ai/get_industry_analysis');
    if(industryAnalysis.status == "ok") {
      const m = {type: "industry", text: industryAnalysis.text_analysis}
      setAiMessages(prev => {
        const isTypeExists = prev.some(msg => msg.type === m.type);
        if (isTypeExists) {
          return prev; // не добавляем m, если такой type уже есть
        }
        return [...prev, m]; // добавляем, если type уникален
      });
      await delay(1000);
      scrollToBottom();
    } else {
      setErrorAI(industryAnalysis.message);
      setLoadingAi(false);
      return ""
    }
    setLoadingIndustryAi(false);

    const newsAnalysis = await runAiAnalysisAPI('/ai/get_news_analysis');
    if(newsAnalysis.status == "ok") {
      const m = {type: "news", text: newsAnalysis.text_analysis}
      setAiMessages(prev => {
        const isTypeExists = prev.some(msg => msg.type === m.type);
        if (isTypeExists) {
          return prev; // не добавляем m, если такой type уже есть
        }
        return [...prev, m]; // добавляем, если type уникален
      });
      await delay(1000);
      scrollToBottom();
    } else {
      setErrorAI(newsAnalysis.message);
      setLoadingAi(false);
      return ""
    }
    setLoadingNewsAi(false);

    const generalAnalysis = await runAiAnalysisAPI('/ai/get_general_analysis');
    if(generalAnalysis.status == "ok") {
      const m = {type: "general", text: generalAnalysis.text_analysis}
      setAiMessages(prev => {
        const isTypeExists = prev.some(msg => msg.type === m.type);
        if (isTypeExists) {
          return prev; // не добавляем m, если такой type уже есть
        }
        return [...prev, m]; // добавляем, если type уникален
      });
      await delay(1000);
      scrollToBottom();
    } else {
      setErrorAI(generalAnalysis.message);
      setLoadingAi(false);
      return ""
    }
    // setLoadingGeneralAi(false);

    const generalOverUnder = await runAiAnalysisAPI('/ai/get_over_under_analysis');
    if(generalOverUnder.status == "ok") {
      const m = {type: "over_under", text: generalOverUnder.text_analysis}
      setCompanyUndervalues(generalOverUnder.text_analysis);
    } else {
      setErrorAI(generalOverUnder.message);
      setLoadingAi(false);
      return ""
    }
    setLoadingGeneralAi(false);

    setLoadingAi(false);
  }

  async function runAiAnalysisAPI(api_enpoint) {
    const token = Cookies.get('token')
    if(!token) {
      setAuthStatus(false);
      return "";
    }
    const data = {
      token: token,
      company_id: id
    }
    try{
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(apiURL+api_enpoint, data)
      return response.data;
    } catch(e) {
      await delay(2000);
      await runAiAnalysisAPI(api_enpoint);
    }
  }

  const contentRef = useRef(null);

  const scrollToBottom = () => {
    if (contentRef.current) {
      contentRef.current.scrollTop = contentRef.current.scrollHeight;
    }
  };

  function TypingMarkdown({ text, speed = 50 }) {
    const [displayedText, setDisplayedText] = useState("");

    useEffect(() => {
      setDisplayedText(""); // при изменении текста сбрасываем
      let currentIndex = 0;

      const intervalId = setInterval(() => {
        currentIndex++;
        setDisplayedText(text.slice(0, currentIndex));
        if (currentIndex >= text.length) {
          clearInterval(intervalId);
        }
      }, speed);

      return () => clearInterval(intervalId);
    }, [text, speed]);

    return <ReactMarkdown>{displayedText}</ReactMarkdown>;
  }

  function setHeaderForAIAnalysis(type_report) {
    if(type_report == "metrics") {
      return "Metrics Analysis"
    } else if (type_report == "country") {
      return "Country Analysis"
    } else if (type_report == "sector") {
      return "Sector Analysis"
    } else if (type_report == "industry") {
      return "Industry Analysis"
    } else if (type_report == "news") {
      return "News Analysis"
    } else if (type_report == "general") {
      return "Analytics Conclusion"
    } else if (type_report == "metrics") {
      return "Metrics Analysis"
    } else if (type_report == "metrics") {
      return "Metrics Analysis"
    } else if (type_report == "metrics") {
      return "Metrics Analysis"
    }
  }

  return (
    <div className="linkedin-layout bg-gray-50 min-h-screen">

      <Modal isOpen={isModalOpenCR} onClose={() => setIsModalOpenCR(false)}>
        <h2 className="linkedin-title">CR (Current Ratio)</h2>
        <p className="linkedin-body-text mb-4">CR (Current Ratio) is a financial metric that measures a company's ability to pay its short-term liabilities with its short-term assets.</p>
        <p className="linkedin-subtitle font-bold">Why is CR Important?</p>
        <ul className="linkedin-body-text space-y-2 mb-6">
          <li className="flex items-start">
            <span className="w-2 h-2 bg-linkedin-blue rounded-full mt-2 mr-3 flex-shrink-0"></span>
            <span><strong>Liquidity Indicator:</strong> A higher current ratio indicates a company has enough assets to cover its short-term debts, while a lower ratio may signal liquidity problems.</span>
          </li>
          <li className="flex items-start">
            <span className="w-2 h-2 bg-linkedin-blue rounded-full mt-2 mr-3 flex-shrink-0"></span>
            <span><strong>Financial Health:</strong> Helps assess a company’s short-term financial stability and ability to meet obligations without needing external financing.</span>
          </li>
          <li className="flex items-start">
            <span className="w-2 h-2 bg-linkedin-blue rounded-full mt-2 mr-3 flex-shrink-0"></span>
            <span><strong>Risk Assessment:</strong> A current ratio below 1 may indicate potential solvency issues, while a very high ratio might suggest inefficient use of assets.</span>
          </li>
        </ul>

        <div className="space-y-3 mb-6">
          <div className="bg-green-50 p-3 rounded-lg">
            <span className="flex items-center linkedin-body-text font-medium">
              <SquareCheck className="mr-2 w-4 h-4 text-green-700" /> 
              <span className="text-green-700">Undervalued - More than 1</span>
            </span>
          </div>

          <div className="bg-red-50 p-3 rounded-lg">
            <span className="flex items-center linkedin-body-text font-medium">
              <SquareX className="mr-2 w-4 h-4 text-red-700" /> 
              <span className="text-red-700">Overvalued - Less than 1</span>
            </span>
          </div>
        </div>

        <button onClick={() => setIsModalOpenCR(false)} className="linkedin-btn-primary w-full">
          Close
        </button>
      </Modal>

      <Modal isOpen={isModalOpenPBR} onClose={() => setIsModalOpenPBR(false)}>
        <h2 className="linkedin-title">PBR (Price-to-Book Ratio) Excluding Intangible Assets and Goodwill</h2>
        <p className="linkedin-body-text mb-4">PBR (Price-to-Book Ratio) Excluding Intangible Assets and Goodwill is a financial metric that compares a company's market value (stock price) to its book value, excluding intangible assets and goodwill.</p>
        <p className="linkedin-subtitle font-bold">Why is PBR Excluding Intangible Assets and Goodwill Important?</p>
        <ul className="linkedin-body-text space-y-2 mb-6">
          <li className="flex items-start">
            <span className="w-2 h-2 bg-linkedin-blue rounded-full mt-2 mr-3 flex-shrink-0"></span>
            <span><strong>Tangible Asset Focus:</strong> By excluding intangible assets and goodwill, this version of the PBR focuses on the company's physical and financial assets, providing a clearer view of its intrinsic value.</span>
          </li>
          <li className="flex items-start">
            <span className="w-2 h-2 bg-linkedin-blue rounded-full mt-2 mr-3 flex-shrink-0"></span>
            <span><strong>Valuation Insight:</strong> It helps investors evaluate whether a company is undervalued or overvalued based on its tangible assets, which are generally more reliable than intangible assets.</span>
          </li>
          <li className="flex items-start">
            <span className="w-2 h-2 bg-linkedin-blue rounded-full mt-2 mr-3 flex-shrink-0"></span>
            <span><strong>Risk Assessment:</strong> Companies with high intangible assets or goodwill may have inflated book values, and excluding these can give a more realistic picture of their true market value.</span>
          </li>
        </ul>

        <div className="space-y-3 mb-6">
          <div className="bg-green-50 p-3 rounded-lg">
            <span className="flex items-center linkedin-body-text font-medium">
              <SquareCheck className="mr-2 w-4 h-4 text-green-700" /> 
              <span className="text-green-700">Undervalued - Less than 1.5</span>
            </span>
          </div>

          <div className="bg-red-50 p-3 rounded-lg">
            <span className="flex items-center linkedin-body-text font-medium">
              <SquareX className="mr-2 w-4 h-4 text-red-700" /> 
              <span className="text-red-700">Overvalued - More than 1.5</span>
            </span>
          </div>
        </div>

        <button onClick={() => setIsModalOpenPBR(false)} className="linkedin-btn-primary w-full">
          Close
        </button>
      </Modal>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div className="hidden lg:block lg:col-span-1">
            <LinkedInSidebar currentPage={currentPage} setCurrentPage={setCurrentPage} />

            <Notification setCurrentPage={setCurrentPage} company_id={id} auth_status={authStatus} notification_enabled={notificationEnabled} />
          </div>

          {loading === true && (
            <div className="lg:col-span-3 space-y-6">
              <div className='mx-auto w-fit'>
                <button className="linkedin-action-btn" disabled={loading}>
                  <span>Loading...</span>
                </button>
              </div>
            </div>
          )}
          
          {loading === false && (
            <div className="lg:col-span-3 space-y-6">
              {/* Company Header */}
              <div className="linkedin-card">
                <div className="linkedin-card-content">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
                    <div className="flex items-center space-x-4 mb-4 md:mb-0">
                      <div className="w-16 h-16 bg-gray-400 bg-opacity-10 rounded-lg flex items-center justify-center">
                        {/* <span className="font-bold text-linkedin-blue text-2xl">{companyDetails.symbol}</span> */}
                        <img src={companyDetails.image} />
                      </div>
                      <div>
                        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">{companyDetails.company_name}</h1>
                        <p className="text-gray-600">{companyDetails.sector} • {companyDetails.industry}</p>
                        <p className="text-gray-500 text-sm">Country: {companyDetails.country}</p>
                      </div>
                    </div>
                    <div className="text-center md:text-right">
                      <p className="text-3xl md:text-4xl font-bold text-gray-900">${companyDetails.stock_price}</p>
                      {/* <p className={`text-lg ${stock.change >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                        {stock.change >= 0 ? '+' : ''}{stock.change} ({stock.changePercent}%)
                      </p> */}
                      <p className="text-sm text-gray-600">Success Rate: {companyDetails.success_rate}%</p>
                    </div>
                  </div>

                  <button 
                    onClick={() => navigate('/feed')}
                    className="text-linkedin-blue hover:underline text-sm font-medium"
                  >
                    ← Back to Feed
                  </button>
                </div>
              </div>

              {/* Basic Financial Metrics */}
              <div className="linkedin-card">
                <div className="linkedin-card-header">
                  <h2 className="text-xl font-bold text-gray-900">Basic Financial Metrics</h2>
                </div>
                <div className="linkedin-card-content">
                  <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-4">
                    <div className="linkedin-metric">
                      <span className="linkedin-metric-label">Market Cap</span>
                      <span className="linkedin-metric-value">
                        <span className="flex justify-center items-center font-medium">
                          {Intl.NumberFormat('en-EN').format(companyDetails.market_cap)} M
                        </span>
                      </span>
                    </div>
                    <div className="linkedin-metric">
                      <span className="linkedin-metric-label">
                        <span className="flex justify-center items-center">
                          Current Ratio
                          <div onClick={() => setIsModalOpenCR(true)}>
                            <Info className="ml-1 w-3 h-3 text-gray-600" />
                          </div>
                        </span>
                      </span>
                      <span className="linkedin-metric-value">
                        <span className="flex justify-center items-center font-medium">
                          {(companyDetails.calculation_results.cr >= 1) && (
                            <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                          )}
                          {!(companyDetails.calculation_results.cr >= 1) && (
                            <SquareX className="mr-1 w-3 h-3 text-red-700" />
                          )}
                          {companyDetails.calculation_results.cr.toFixed(2)}
                        </span>
                      </span>
                    </div>
                    <div className="linkedin-metric">
                      <span className="linkedin-metric-label">
                        <span className="flex justify-center items-center">
                          PBR
                          <div onClick={() => setIsModalOpenPBR(true)}>
                            <Info className="ml-1 w-3 h-3 text-gray-600" />
                          </div>
                        </span>
                      </span>
                      <span className="linkedin-metric-value">
                        <span className="flex justify-center items-center font-medium">
                          {(companyDetails.calculation_results.pbr <= 1.5) && (
                            <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                          )}
                          {!(companyDetails.calculation_results.pbr <= 1.5) && (
                            <SquareX className="mr-1 w-3 h-3 text-red-700" />
                          )}
                          {companyDetails.calculation_results.pbr.toFixed(2)}
                        </span>
                      </span>
                    </div>
                    <div className="linkedin-metric">
                      <span className="linkedin-metric-label">Success Rate</span>
                      <span className="linkedin-metric-value"><span className="flex justify-center items-center font-medium">{companyDetails.success_rate}%</span></span>
                    </div>
                  </div>
                </div>
              </div>

              {/* AI Analytics */}
              <div className="linkedin-card">
                <div className="linkedin-card-header">
                  <h2 className="text-xl font-bold text-gray-900">AI Analytics</h2>
                  <div className="font-regular text-left text-xs">
                    Metrics Analysis, Industry and Sector Analysis, Country Risk Analysis, Latest News Analysis, and General Analysis.
                  </div>
                </div>
                <div ref={contentRef} className="linkedin-card-content max-h-[500px] overflow-y-auto">

                  {authStatus === false && (
                    <div className="w-full flex flex-col p-4 w-[100%]">
                      <div className="bg-white rounded-lg p-4">
                        <p className="text-lg text-center font-bold">Log in to your account to access AI Analysis</p>
                        <p className="text-sm text-center font-regular">Create one for free on Fractofolio to unlock AI-powered insights.</p>
                        <div className="mx-auto w-fit mt-3">
                          <button 
                            onClick={() => navigateToPage('auth/signup')}
                            className="linkedin-btn-primary text-sm px-4 py-1.5"
                          >
                            Join now
                          </button>
                        </div>
                        <div className="mx-auto w-fit mt-1">
                          <span onClick={() => navigateToPage('auth/login')} className="text-sm text-center font-regular underline cursor-pointer">Log in</span>
                        </div>
                      </div>
                    </div>
                  )}

                  

                  

                  {authStatus === true && (
                    <>

                      {loadingAi === true && (
                        <>
                          <div className="">
                            <div className="flex items-center space-x-1">
                              {loadingMetricsAi === true && (
                                <Loader2 className="animate-spin h-6 w-6 text-gray-500" />
                              )}
                              {loadingMetricsAi === false && (
                                <Check className="h-6 w-6 text-green-500" />
                              )}
                              <div className="text-sm font-medium">
                                Metrics Analytics
                              </div>
                            </div>
                          </div>

                          <div className="">
                            <div className="flex items-center space-x-1">
                              {loadingCountryAi === true && (
                                <Loader2 className="animate-spin h-6 w-6 text-gray-500" />
                              )}
                              {loadingCountryAi === false && (
                                <Check className="h-6 w-6 text-green-500" />
                              )}
                              <div className="text-sm font-medium">
                                Country Analytics
                              </div>
                            </div>
                          </div>

                          <div className="">
                            <div className="flex items-center space-x-1">
                              {loadingSectorAi === true && (
                                <Loader2 className="animate-spin h-6 w-6 text-gray-500" />
                              )}
                              {loadingSectorAi === false && (
                                <Check className="h-6 w-6 text-green-500" />
                              )}
                              <div className="text-sm font-medium">
                                Sector Analytics
                              </div>
                            </div>
                          </div>

                          <div className="">
                            <div className="flex items-center space-x-1">
                              {loadingIndustryAi === true && (
                                <Loader2 className="animate-spin h-6 w-6 text-gray-500" />
                              )}
                              {loadingIndustryAi === false && (
                                <Check className="h-6 w-6 text-green-500" />
                              )}
                              <div className="text-sm font-medium">
                                Industry Analytics
                              </div>
                            </div>
                          </div>

                          <div className="">
                            <div className="flex items-center space-x-1">
                              {loadingNewsAi === true && (
                                <Loader2 className="animate-spin h-6 w-6 text-gray-500" />
                              )}
                              {loadingNewsAi === false && (
                                <Check className="h-6 w-6 text-green-500" />
                              )}
                              <div className="text-sm font-medium">
                                News Analytics
                              </div>
                            </div>
                          </div>

                          <div className="">
                            <div className="flex items-center space-x-1">
                              {loadingGeneralAi === true && (
                                <Loader2 className="animate-spin h-6 w-6 text-gray-500" />
                              )}
                              {loadingGeneralAi === false && (
                                <Check className="h-6 w-6 text-green-500" />
                              )}
                              <div className="text-sm font-medium">
                                Analytics Conclusion
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      
                      {loadingAi === false && errorAI == "" && (
                        <div className="linkedin-metric-value">

                          {companyUndervalues != "" && (
                            <div className="mt-1 mb-2">
                              <ToggleBlock header=" Undervalued or Overvalued" text={`The company is ${companyUndervalues}`} defaultOpen={true} />
                            </div>
                          )}

                          {aiMessages && aiMessages.map((item, key) => (
                            <>
                              {item.type == "general" && (
                                <div key={'key_general_analysis_1'} className="mt-1 mb-2">
                                  <ToggleBlock header={setHeaderForAIAnalysis(item.type)} text={item.text} defaultOpen={true} />
                                </div>
                              )}
                            </>
                          ))}

                          {aiMessages && aiMessages.map((item, key) => (
                            <>
                              {item.type != "general" && (
                                <div key={`key_ai_analysis_${item.type}`} className="mt-1 mb-2">
                                  <ToggleBlock header={setHeaderForAIAnalysis(item.type)} text={item.text} />
                                </div>
                              )}
                            </>
                          ))}
                        </div>
                      )}

                      {loadingAi === false && errorAI != "" && (
                        <div className="linkedin-metric-value">
                          <div className="mt-5 w-full bg-red-100 rounded-md p-3">
                            <p className="text-sm font-main-medium text-black">{errorAI}</p>
                          </div>
                          <div className="mx-auto w-fit">
                            <button onClick={() => navigateToPage('subscriptions')} className="mt-3 linkedin-btn-secondary">Subscribe to Pro</button>
                          </div>
                        </div>
                      )}

                      
                    </>
                  )}

                </div>

                {authStatus === true && aiMessages.length == 0 && !errorAI?.includes("You have reached the limit") && (
                  <div className="linkedin-card-content">
                    <div className="mx-auto w-fit">
                      <button onClick={() => runAiAnalysis()} disabled={loadingAi} className="linkedin-btn-primary text-sm px-4 py-1.5">
                        {loadingAi === false && (
                          <span>Run AI Analysis for {companyDetails.company_name}</span>
                        )}
                        {loadingAi === true && (
                          <span>Loading...</span>
                        )}
                      </button>
                    </div>
                  </div>
                )}

              </div>

              {/* Notification Section */}
              <div className="block lg:hidden">
                <Notification setCurrentPage={setCurrentPage} company_id={id} auth_status={authStatus} notification_enabled={notificationEnabled} />
              </div>

              {/* Valuation Ratios */}
              <div className="linkedin-card">
                <div className="linkedin-card-header">
                  <h2 className="text-xl font-bold text-gray-900">Valuation Ratios</h2>
                </div>
                <div className="linkedin-card-content">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-gray-900 mb-2">PE Ratio (Price-to-Earnings)</h3>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Current Year:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.pe.pe <= 15 && companyDetails.calculation_results.pe.pe > 0) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.pe.pe <= 15 && companyDetails.calculation_results.pe.pe > 0) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.pe.pe.toFixed(2)}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">3-Year Avg:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.pe.pe_3y <= 15 && companyDetails.calculation_results.pe.pe_3y > 0) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.pe.pe_3y <= 15 && companyDetails.calculation_results.pe.pe_3y > 0) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.pe.pe_3y.toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-gray-900 mb-2">PCF Ratio (Price-to-Cash Flow)</h3>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Current Year:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.pcf.pcf <= 15 && companyDetails.calculation_results.pcf.pcf > 0) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.pcf.pcf <= 15 && companyDetails.calculation_results.pcf.pcf > 0) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.pcf.pcf.toFixed(2)}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">3-Year Avg:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.pcf.pcf_3y <= 15 && companyDetails.calculation_results.pcf.pcf_3y > 0) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.pcf.pcf_3y <= 15 && companyDetails.calculation_results.pcf.pcf_3y > 0) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.pcf.pcf_3y.toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-gray-900 mb-2">PS Ratio (Price-to-Sales)</h3>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Current Year:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.ps.ps <= 2) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.ps.ps <= 2) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.ps.ps.toFixed(2)}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">3-Year Avg:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.ps.ps_3y <= 2) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.ps.ps_3y <= 2) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.ps.ps_3y.toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-gray-900 mb-2">One Dollar Premise (ODP)</h3>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Return per $1:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.odd >= 1) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.odd >= 1) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.odd.toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Profitability & Financial Health */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className="linkedin-card">
                  <div className="linkedin-card-header">
                    <h2 className="text-xl font-bold text-gray-900">Profitability Metrics</h2>
                  </div>
                  <div className="linkedin-card-content space-y-4">
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-gray-900 mb-2">Net Profit Margin (NPM)</h3>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Current:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.net_profit_margin.net_profit_margin >= 15) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.net_profit_margin.net_profit_margin >= 15) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.net_profit_margin.net_profit_margin.toFixed(2)}%
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">10-Year Avg:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.net_profit_margin.net_profit_margin_10y >= 15) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.net_profit_margin.net_profit_margin_10y >= 15) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.net_profit_margin.net_profit_margin_10y.toFixed(2)}%
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Difference:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.net_profit_margin.net_profit_margin_difference >= 0) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.net_profit_margin.net_profit_margin_difference >= 0) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.net_profit_margin.net_profit_margin_difference.toFixed(2)}%
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="bg-green-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-gray-900 mb-2">Return on Equity (ROE)</h3>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Current:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.roe.roe >= 15) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.roe.roe >= 15) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.roe.roe.toFixed(2)}%
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">10-Year Avg:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.roe.roe_10y >= 15) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.roe.roe_10y >= 15) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.roe.roe_10y.toFixed(2)}%
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Difference:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.roe.roe_difference_10y >= 15) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.roe.roe_difference_10y >= 15) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.roe.roe_difference_10y.toFixed(2)}%
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="linkedin-card">
                  <div className="linkedin-card-header">
                    <h2 className="text-xl font-bold text-gray-900">Financial Health</h2>
                  </div>
                  <div className="linkedin-card-content space-y-4">
                    <div className="bg-orange-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-gray-900 mb-2">Debt-to-Asset Ratio (DAR)</h3>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Current:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.dar.dar <= 1) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.dar.dar <= 1) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.dar.dar.toFixed(2)}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">10-Year Avg:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.dar.dar_10y <= 1) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.dar.dar_10y <= 1) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.dar.dar_10y.toFixed(2)}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Difference:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.dar.dar_difference <= 0) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.dar.dar_difference <= 0) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.dar.dar_difference.toFixed(2)}%
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="bg-purple-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-gray-900 mb-2">Operating Ratio (OR)</h3>
                      <div className="space-y-2">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Current:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.operating_ratio.operating_ratio <= 85) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.operating_ratio.operating_ratio <= 85) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.operating_ratio.operating_ratio.toFixed(2)}
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">10-Year Avg:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.operating_ratio.operating_ratio_10y <= 85) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.operating_ratio.operating_ratio_10y <= 85) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.operating_ratio.operating_ratio_10y.toFixed(2)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Growth & Yield Metrics */}
              <div className="linkedin-card">
                <div className="linkedin-card-header">
                  <h2 className="text-xl font-bold text-gray-900">Growth & Yield Analysis</h2>
                </div>
                <div className="linkedin-card-content">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <div className="bg-green-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-gray-900 mb-2">Dividend Yield (DY)</h3>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Current:</span>
                          <span className="flex justify-between items-center font-medium">{companyDetails.calculation_results.dividend.dividend_yields[0].toFixed(2)}%</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">10-Year:</span>
                          <span className="flex justify-between items-center font-medium">{companyDetails.calculation_results.dividend.dividend_yields[companyDetails.calculation_results.dividend.dividend_yields.length-1].toFixed(2)}%</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Difference:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.dividend.difference_dividend_yield >= 0) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.dividend.difference_dividend_yield >= 0) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.dividend.difference_dividend_yield.toFixed(2)}%
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-gray-900 mb-2">Potential Growth</h3>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Country:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.potential_grow.largest_company_in_sector >= 1000) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.potential_grow.largest_company_in_sector >= 1000) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.potential_grow.largest_company_in_sector.toFixed(2)}%
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Sector:</span>
                          <span className="flex justify-between items-center font-medium">
                            {(companyDetails.calculation_results.potential_grow.sector_global >= 1000) && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {!(companyDetails.calculation_results.potential_grow.sector_global >= 1000) && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.potential_grow.sector_global.toFixed(2)}%
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="bg-yellow-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-gray-900 mb-2">Growth Rates</h3>
                      <div className="space-y-1">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">FCF 3Y:</span>
                          <span className="flex justify-between items-center font-medium">
                            {companyDetails.ty_10y <= companyDetails.calculation_results.free_cash_flow_per_share.free_cash_flow_per_share_growth_avg_3y && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {companyDetails.ty_10y > companyDetails.calculation_results.free_cash_flow_per_share.free_cash_flow_per_share_growth_avg_3y && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.free_cash_flow_per_share.free_cash_flow_per_share_growth_avg_3y.toFixed(2)}%
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">FCF 10Y:</span>
                          <span className="flex justify-between items-center font-medium">
                            {companyDetails.ty_10y <= companyDetails.calculation_results.free_cash_flow_per_share.free_cash_flow_per_share_growth_avg_10y && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {companyDetails.ty_10y > companyDetails.calculation_results.free_cash_flow_per_share.free_cash_flow_per_share_growth_avg_10y && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.free_cash_flow_per_share.free_cash_flow_per_share_growth_avg_10y.toFixed(2)}%
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">EPS 3Y:</span>
                            <span className="flex justify-between items-center font-medium">
                              {companyDetails.ty_10y <= companyDetails.calculation_results.eps.eps_growth_avg_3y && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {companyDetails.ty_10y > companyDetails.calculation_results.eps.eps_growth_avg_3y && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.eps.eps_growth_avg_3y.toFixed(2)}%
                          </span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">EPS 10Y:</span>
                          <span className="flex justify-between items-center font-medium">
                            {companyDetails.ty_10y <= companyDetails.calculation_results.eps.eps_growth_avg_10y && (
                              <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                            )}
                            {companyDetails.ty_10y > companyDetails.calculation_results.eps.eps_growth_avg_10y && (
                              <SquareX className="mr-1 w-3 h-3 text-red-700" />
                            )}
                            {companyDetails.calculation_results.eps.eps_growth_avg_10y.toFixed(2)}%
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Macroeconomic & Future Projections */}
              <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
                <div className="linkedin-card">
                  <div className="linkedin-card-header">
                    <h2 className="text-xl font-bold text-gray-900">Macroeconomic Context</h2>
                  </div>
                  <div className="linkedin-card-content space-y-4">
                    <div className="bg-red-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-gray-900 mb-2">Country Debt to GDP (CDGDP)</h3>
                      <div className="text-center">
                        <span className="text-2xl font-bold text-gray-900 flex justify-center items-center">
                          {companyDetails.cd_gdp <= 100 && (
                            <SquareCheck className="mr-1 w-4 h-4 text-green-700" />
                          )}
                          {!(companyDetails.cd_gdp <= 100) && (
                            <SquareX className="mr-1 w-4 h-4 text-red-700" />
                          )}
                          {companyDetails.cd_gdp}%
                          </span>
                      </div>
                    </div>
                    
                    <div className="bg-indigo-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-gray-900 mb-2">Treasury Yield (TY)</h3>
                      <div className="text-center">
                        <span className="text-2xl font-bold text-gray-900">{companyDetails.ty_10y}%</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="linkedin-card">
                  <div className="linkedin-card-header">
                    <h2 className="text-xl font-bold text-gray-900">Free Cash Flow Analysis</h2>
                  </div>
                  <div className="linkedin-card-content">
                    <div className="bg-teal-50 p-4 rounded-lg mb-4">
                      <h3 className="font-semibold text-gray-900 mb-2">FCF per Share: ${companyDetails.calculation_results.free_cash_flow_per_share.free_cash_flow_per_share[0].toFixed(2)}</h3>
                      {/* <div className="text-xs text-gray-600">
                        10-Year Trend: {companyDetails.calculation_results.free_cash_flow_per_share.free_cash_flow_per_share.slice(-10).join(' → ')}
                      </div> */}

                      <div className="mx-auto flex flex-wrap gap-5 w-full justify-between">

                        {cashFlowAllData && cashFlowAllData.map((item, key) => (
                          <div key={`cf_${key}`} className="text-left w-[calc(100%/5-1rem)] max-w-[calc(100%/5-1rem)]">
                            <p className="text-xs text-gray-500 font-main-medium">
                              {item.year}
                            </p>
                            <p className="justify-center items-center text-gray-700 text-lg font-bold">
                              {converToCorrectValue(item.value)}
                            </p>
                            {key < cashFlowAllData.length - 1 && (
                              <p className={`flex justify-start items-center text-xs sm:text-xs ${item.difference >= 0 ? "text-green-700" : "text-red-700"}`}>
                                {item.difference >= 0 && (
                                  <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                                )}
                                {item.difference < 0 && (
                                  <SquareX className="mr-1 w-3 h-3 text-red-700" />
                                )}
                                {converToCorrectValue(item.difference)}%
                              </p>
                            )}
                          </div>
                        ))}

                      </div>
                      
                    </div>
                    
                    <div className="space-y-3">
                      <div>
                        <h4 className="font-medium text-gray-900 mb-1">Future Stock Price Projections</h4>
                        <div className="grid grid-cols-2 gap-3 text-sm">
                          <div className="bg-gray-100 p-2 rounded">
                            <div className="text-xs text-gray-600">Last Year Model</div>
                            <div className="flex items-center font-medium">
                              High: 
                              {companyDetails.calculation_results.free_cash_flow_per_share.future_stock_price.high >= companyDetails.stock_price && (
                                <SquareCheck className="ml-1 mr-1 w-3 h-3 text-green-700" />
                              )}
                              {!(companyDetails.calculation_results.free_cash_flow_per_share.future_stock_price.high >= companyDetails.stock_price) && (
                                <SquareX className="ml-1 mr-1 w-3 h-3 text-red-700" />
                              )}
                              ${companyDetails.calculation_results.free_cash_flow_per_share.future_stock_price.high.toFixed(2)}</div>
                            <div className="flex items-center font-medium">
                              Low:
                              {companyDetails.calculation_results.free_cash_flow_per_share.future_stock_price.low >= companyDetails.stock_price && (
                                <SquareCheck className="ml-1 mr-1 w-3 h-3 text-green-700" />
                              )}
                              {!(companyDetails.calculation_results.free_cash_flow_per_share.future_stock_price.low >= companyDetails.stock_price) && (
                                <SquareX className="ml-1 mr-1 w-3 h-3 text-red-700" />
                              )}
                              ${companyDetails.calculation_results.free_cash_flow_per_share.future_stock_price.low.toFixed(2)}</div>
                          </div>
                          <div className="bg-gray-100 p-2 rounded">
                            <div className="text-xs text-gray-600">3-Year Avg Model</div>
                            <div className="flex items-center font-medium">
                              High:
                              {companyDetails.calculation_results.free_cash_flow_per_share.future_stock_price.high_3y_model >= companyDetails.stock_price && (
                                <SquareCheck className="ml-1 mr-1 w-3 h-3 text-green-700" />
                              )}
                              {!(companyDetails.calculation_results.free_cash_flow_per_share.future_stock_price.high_3y_model >= companyDetails.stock_price) && (
                                <SquareX className="ml-1 mr-1 w-3 h-3 text-red-700" />
                              )}
                              ${companyDetails.calculation_results.free_cash_flow_per_share.future_stock_price.high_3y_model.toFixed(2)}</div>
                            <div className="flex items-center font-medium">
                              Low:
                              {companyDetails.calculation_results.free_cash_flow_per_share.future_stock_price.low_3y_model >= companyDetails.stock_price && (
                                <SquareCheck className="ml-1 mr-1 w-3 h-3 text-green-700" />
                              )}
                              {!(companyDetails.calculation_results.free_cash_flow_per_share.future_stock_price.low_3y_model >= companyDetails.stock_price) && (
                                <SquareX className="ml-1 mr-1 w-3 h-3 text-red-700" />
                              )}
                              ${companyDetails.calculation_results.free_cash_flow_per_share.future_stock_price.low_3y_model.toFixed(2)}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="linkedin-card">
                  <div className="linkedin-card-header">
                    <h2 className="text-xl font-bold text-gray-900">Earning per Share (EPS)</h2>
                  </div>
                  <div className="linkedin-card-content">
                    <div className="bg-teal-50 p-4 rounded-lg mb-4">
                      <h3 className="font-semibold text-gray-900 mb-2">EPS: ${companyDetails.calculation_results.eps.eps[0].toFixed(2)}</h3>
                      {/* <div className="text-xs text-gray-600">
                        10-Year Trend: {companyDetails.calculation_results.free_cash_flow_per_share.free_cash_flow_per_share.slice(-10).join(' → ')}
                      </div> */}

                      <div className="mx-auto flex flex-wrap gap-5 w-full justify-between">

                        {epsAllData && epsAllData.map((item, key) => (
                          <div key={`cf_${key}`} className="text-left w-[calc(100%/5-1rem)] max-w-[calc(100%/5-1rem)]">
                            <p className="text-xs text-gray-500 font-main-medium">
                              {item.year}
                            </p>
                            <p className="justify-center items-center text-gray-700 text-lg font-bold">
                              {converToCorrectValue(item.value)}
                            </p>
                            {key < epsAllData.length - 1 && (
                              <p className={`flex justify-start items-center text-xs sm:text-xs ${item.difference >= 0 ? "text-green-700" : "text-red-700"}`}>
                                {item.difference >= 0 && (
                                  <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                                )}
                                {item.difference < 0 && (
                                  <SquareX className="mr-1 w-3 h-3 text-red-700" />
                                )}
                                {converToCorrectValue(item.difference)}%
                              </p>
                            )}
                          </div>
                        ))}

                      </div>
                      
                    </div>
                    
                    <div className="space-y-3">
                      <div>
                        <h4 className="font-medium text-gray-900 mb-1">Future Stock Price Projections</h4>
                        <div className="grid grid-cols-2 gap-3 text-sm">
                          <div className="bg-gray-100 p-2 rounded">
                            <div className="text-xs text-gray-600">Last Year Model</div>
                            <div className="flex items-center font-medium">
                              High:
                              {companyDetails.calculation_results.eps.future_stock_price.high >= companyDetails.stock_price && (
                                <SquareCheck className="ml-1 mr-1 w-3 h-3 text-green-700" />
                              )}
                              {!(companyDetails.calculation_results.eps.future_stock_price.high >= companyDetails.stock_price) && (
                                <SquareX className="ml-1 mr-1 w-3 h-3 text-red-700" />
                              )}
                              ${companyDetails.calculation_results.eps.future_stock_price.high.toFixed(2)}
                            </div>
                            <div className="flex items-center font-medium">
                              Low:
                              {companyDetails.calculation_results.eps.future_stock_price.low >= companyDetails.stock_price && (
                                <SquareCheck className="ml-1 mr-1 w-3 h-3 text-green-700" />
                              )}
                              {!(companyDetails.calculation_results.eps.future_stock_price.low >= companyDetails.stock_price) && (
                                <SquareX className="ml-1 mr-1 w-3 h-3 text-red-700" />
                              )}
                              ${companyDetails.calculation_results.eps.future_stock_price.low.toFixed(2)}
                            </div>
                          </div>
                          <div className="bg-gray-100 p-2 rounded">
                            <div className="text-xs text-gray-600">3-Year Avg Model</div>
                            <div className="flex items-center font-medium">
                              High:
                              {companyDetails.calculation_results.eps.future_stock_price.high_3y_model >= companyDetails.stock_price && (
                                <SquareCheck className="ml-1 mr-1 w-3 h-3 text-green-700" />
                              )}
                              {!(companyDetails.calculation_results.eps.future_stock_price.high_3y_model >= companyDetails.stock_price) && (
                                <SquareX className="ml-1 mr-1 w-3 h-3 text-red-700" />
                              )}
                              ${companyDetails.calculation_results.eps.future_stock_price.high_3y_model.toFixed(2)}
                            </div>
                            <div className="flex items-center font-medium">
                              Low:
                              {companyDetails.calculation_results.eps.future_stock_price.low_3y_model >= companyDetails.stock_price && (
                                <SquareCheck className="ml-1 mr-1 w-3 h-3 text-green-700" />
                              )}
                              {!(companyDetails.calculation_results.eps.future_stock_price.low_3y_model >= companyDetails.stock_price) && (
                                <SquareX className="ml-1 mr-1 w-3 h-3 text-red-700" />
                              )}
                              ${companyDetails.calculation_results.eps.future_stock_price.low_3y_model.toFixed(2)}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="linkedin-card">
                  <div className="linkedin-card-header">
                    <h2 className="text-xl font-bold text-gray-900">Revenue per Share (RPS)</h2>
                  </div>
                  <div className="linkedin-card-content">
                    <div className="bg-teal-50 p-4 rounded-lg mb-4">
                      <h3 className="font-semibold text-gray-900 mb-2">RPS: ${companyDetails.calculation_results.revenue.revenue_per_share[0].toFixed(2)}</h3>
                      {/* <div className="text-xs text-gray-600">
                        10-Year Trend: {companyDetails.calculation_results.free_cash_flow_per_share.free_cash_flow_per_share.slice(-10).join(' → ')}
                      </div> */}

                      <div className="mx-auto flex flex-wrap gap-5 w-full justify-between">

                        {revenueAllData && revenueAllData.map((item, key) => (
                          <div key={`cf_${key}`} className="text-left w-[calc(100%/5-1rem)] max-w-[calc(100%/5-1rem)]">
                            <p className="text-xs text-gray-500 font-main-medium">
                              {item.year}
                            </p>
                            <p className="justify-center items-center text-gray-700 text-lg font-bold">
                              {converToCorrectValue(item.value)}
                            </p>
                            {key < revenueAllData.length - 1 && (
                              <p className={`flex justify-start items-center text-xs sm:text-xs ${item.difference >= 0 ? "text-green-700" : "text-red-700"}`}>
                                {item.difference >= 0 && (
                                  <SquareCheck className="mr-1 w-3 h-3 text-green-700" />
                                )}
                                {item.difference < 0 && (
                                  <SquareX className="mr-1 w-3 h-3 text-red-700" />
                                )}
                                {converToCorrectValue(item.difference)}%
                              </p>
                            )}
                          </div>
                        ))}

                      </div>
                      
                    </div>
                    
                    <div className="space-y-3">
                      <div>
                        <h4 className="font-medium text-gray-900 mb-1">Future Stock Price Projections</h4>
                        <div className="grid grid-cols-2 gap-3 text-sm">
                          <div className="bg-gray-100 p-2 rounded">
                            <div className="text-xs text-gray-600">Last Year Model</div>
                            <div className="flex items-center font-medium">
                              High:
                              {companyDetails.calculation_results.revenue.future_stock_price.high >= companyDetails.stock_price && (
                                <SquareCheck className="ml-1 mr-1 w-3 h-3 text-green-700" />
                              )}
                              {!(companyDetails.calculation_results.revenue.future_stock_price.high >= companyDetails.stock_price) && (
                                <SquareX className="ml-1 mr-1 w-3 h-3 text-red-700" />
                              )}
                              ${companyDetails.calculation_results.revenue.future_stock_price.high.toFixed(2)}
                            </div>
                            <div className="flex items-center font-medium">
                              Low:
                              {companyDetails.calculation_results.revenue.future_stock_price.low >= companyDetails.stock_price && (
                                <SquareCheck className="ml-1 mr-1 w-3 h-3 text-green-700" />
                              )}
                              {!(companyDetails.calculation_results.revenue.future_stock_price.low >= companyDetails.stock_price) && (
                                <SquareX className="ml-1 mr-1 w-3 h-3 text-red-700" />
                              )}
                              ${companyDetails.calculation_results.revenue.future_stock_price.low.toFixed(2)}
                            </div>
                          </div>
                          <div className="bg-gray-100 p-2 rounded">
                            <div className="text-xs text-gray-600">3-Year Avg Model</div>
                            <div className="flex items-center font-medium">
                              High:
                              {companyDetails.calculation_results.revenue.future_stock_price.high_3y_model >= companyDetails.stock_price && (
                                <SquareCheck className="ml-1 mr-1 w-3 h-3 text-green-700" />
                              )}
                              {!(companyDetails.calculation_results.revenue.future_stock_price.high_3y_model >= companyDetails.stock_price) && (
                                <SquareX className="ml-1 mr-1 w-3 h-3 text-red-700" />
                              )}
                              ${companyDetails.calculation_results.revenue.future_stock_price.high_3y_model.toFixed(2)}
                            </div>
                            <div className="flex items-center font-medium">
                              Low:
                              {companyDetails.calculation_results.revenue.future_stock_price.low_3y_model >= companyDetails.stock_price && (
                                <SquareCheck className="ml-1 mr-1 w-3 h-3 text-green-700" />
                              )}
                              {!(companyDetails.calculation_results.revenue.future_stock_price.low_3y_model >= companyDetails.stock_price) && (
                                <SquareX className="ml-1 mr-1 w-3 h-3 text-red-700" />
                              )}
                              ${companyDetails.calculation_results.revenue.future_stock_price.low_3y_model.toFixed(2)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              {/* Professional Analysts Section */}
              {/* <div className="linkedin-card">
                <div className="linkedin-card-header">
                  <h2 className="text-xl font-bold text-gray-900">Professional Analysts</h2>
                </div>
                <div className="linkedin-card-content">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {stock.analysts.map((analyst, index) => (
                      <div key={index} className="flex items-center space-x-4 p-4 bg-gray-50 rounded-lg">
                        <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-200">
                          <img 
                            src={analyst.avatar} 
                            alt={analyst.name}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="flex-1">
                          <p className="font-semibold text-gray-900">{analyst.name}</p>
                          <p className={`text-sm font-medium ${
                            analyst.rating === 'Strong Buy' ? 'text-green-700' :
                            analyst.rating === 'Buy' ? 'text-green-600' :
                            analyst.rating === 'Hold' ? 'text-yellow-600' :
                            'text-red-600'
                          }`}>
                            {analyst.rating}
                          </p>
                          <div className="text-xs text-gray-500">
                            <div>Target: ${analyst.target}</div>
                            <div>Confidence: {analyst.confidence}%</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div> */}

              {/* Financial Reports Section */}
              <div className="linkedin-card">
                <div className="linkedin-card-header">
                  <h2 className="text-xl font-bold text-gray-900">Financial Reports</h2>
                </div>
                <div className="linkedin-card-content">
                  
                  {/* Tab Navigation */}
                  <div className="border-b border-gray-200 mb-6">
                    <nav className="flex space-x-8">
                      <button
                        onClick={() => setActiveReportTab('income')}
                        className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
                          activeReportTab === 'income'
                            ? 'border-linkedin-blue text-linkedin-blue'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                        }`}
                      >
                        Income
                      </button>
                      <button
                        onClick={() => setActiveReportTab('balance')}
                        className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
                          activeReportTab === 'balance'
                            ? 'border-linkedin-blue text-linkedin-blue'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                        }`}
                      >
                        Balance Sheet
                      </button>
                      <button
                        onClick={() => setActiveReportTab('cashflow')}
                        className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
                          activeReportTab === 'cashflow'
                            ? 'border-linkedin-blue text-linkedin-blue'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                        }`}
                      >
                        Cash Flow
                      </button>
                    </nav>
                  </div>

                  {/* Tab Content */}
                  <div className="linkedin-fade-in">
                    
                    {/* Income Report */}
                    {activeReportTab === 'income' && (
                      <div className="bg-blue-50 p-6 rounded-lg">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">Income Report</h3>
                        <TableFromJson inputReport={incomeReport} />
                      </div>
                    )}

                    {/* Balance Sheet Report */}
                    {activeReportTab === 'balance' && (
                      <div className="bg-green-50 p-6 rounded-lg">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">Balance Sheet Report</h3>
                        <TableFromJson inputReport={balanceSheetReport} />
                      </div>
                    )}

                    {/* Cash Flow Report */}
                    {activeReportTab === 'cashflow' && (
                      <div className="bg-purple-50 p-6 rounded-lg">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4">Cash Flow Report</h3>
                        <TableFromJson inputReport={cashFlowReport} />
                      </div>
                    )}

                  </div>
                </div>
              </div>

            </div>
          )}

        </div>

      </div>

    </div>  
  );
};

export default CompanyPage;
